
import React from 'react';

const ChatCard = ({ photo, name, post, time, badge }) => {
    return (
        <div className="hidden md:flex items-center p-2 mb-1">
            <div className="flex w-4/5">
                <img src={photo} alt={name} />
                <div className="ml-4">
                    <h2 className="text-xl font-medium text-success-email">{name}</h2>
                    <p className="text-sm font-normal text-success-email">{post}</p>
                </div>
            </div>

            <div className="w-1/5 text-base font-normal text-success-email text-right">
                {time}
            </div>
            {/* <div className="flex justify-end mt-4">
                <span className="inline-block px-3 py-1 text-sm font-semibold text-white bg-blue-500 rounded-full">
                    {badge}
                </span>
            </div> */}
        </div>
    );
};

export default ChatCard;







// import { ChatAvatar } from "../../../components/common/IconComponents";

// const ChatCard = ({ photo, name, post, time, badge }) => {
//     return (
//         <div className="flex items-center p-2">
//             <div className="flex w-4/5">
//                 {photo ? (
//                     <img src={photo} alt={name} className="w-16 h-16 rounded-full" />
//                 ) : (
//                     <ChatAvatar />
//                 )}
//                 <div className="ml-4">
//                     <h2 className="text-xl font-medium text-success-email">{name}</h2>
//                     <p className="text-sm font-normal text-success-email">{post}</p>
//                 </div>
//             </div>

//             <div className="w-1/5 text-base font-normal text-success-email text-right">
//                 {time}
//             </div>
//             {/* <div className="flex justify-end mt-4">
//                 <span className="inline-block px-3 py-1 text-sm font-semibold text-white bg-blue-500 rounded-full">
//                     {badge}
//                 </span>
//             </div> */}
//         </div>
//     );
// };

// export default ChatCard;




// Okay without calling avatar here
// const ChatCard = ({ photo, name, post, time, badge }) => {
//     return (
//         <div className="flex items-center p-2">
//             <div className="flex w-4/5">
//                 <img src={photo} alt={name} className="w-16 h-16 rounded-full" />
//                 <div className="ml-4">
//                     <h2 className="text-xl font-medium text-success-email">{name}</h2>
//                     <p className="text-sm font-normal text-success-email">{post}</p>
//                 </div>
//             </div>

//             <div className="w-1/5 text-base font-normal text-success-email text-right">
//                 {time}
//             </div>
//             {/* <div className="flex justify-end mt-4">
//                 <span className="inline-block px-3 py-1 text-sm font-semibold text-white bg-blue-500 rounded-full">
//                     {badge}
//                 </span>
//             </div> */}
//         </div>
//     );
// };

// export default ChatCard;
